module.exports = __webpack_public_path__ + "media/images/img_badge_reservation-e1dabe3c21809ee255a0317e7a28a14a.png";